import React from 'react';

function ToastSuccessIcon() {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.3">
        <path
          d="M5.49984 18.0003C5.49984 11.0968 11.0963 5.50033 17.9998 5.50033C24.9034 5.50033 30.4998 11.0968 30.4998 18.0003C30.4998 24.9039 24.9034 30.5003 17.9998 30.5003C11.0963 30.5003 5.49984 24.9039 5.49984 18.0003Z"
          stroke="#079455"
          stroke-width="1.66667"
        />
      </g>
      <g opacity="0.1">
        <path
          d="M1.33333 18C1.33333 8.79525 8.79525 1.33333 18 1.33333C27.2047 1.33333 34.6667 8.79525 34.6667 18C34.6667 27.2047 27.2047 34.6667 18 34.6667C8.79525 34.6667 1.33333 27.2047 1.33333 18Z"
          stroke="#079455"
          stroke-width="1.66667"
        />
      </g>
      <g clip-path="url(#clip0_43307_101)">
        <path
          d="M14.2498 18.0003L16.7498 20.5003L21.7498 15.5003M26.3332 18.0003C26.3332 22.6027 22.6022 26.3337 17.9998 26.3337C13.3975 26.3337 9.6665 22.6027 9.6665 18.0003C9.6665 13.398 13.3975 9.66699 17.9998 9.66699C22.6022 9.66699 26.3332 13.398 26.3332 18.0003Z"
          stroke="#079455"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_43307_101">
          <rect width="20" height="20" fill="white" transform="translate(8 8)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ToastSuccessIcon;
